import PropTypes from 'prop-types';
import { useMixpanel } from 'react-mixpanel-browser';
import { useSelector } from 'react-redux';

import { AnalyticsToggler } from './AnalyticsToggler';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { getSupportedCurrenciesForSupplier } from './utils';

import { CURRENCIES } from '../../../constants/analytics';

import styles from './Dashboard.module.scss';

export function AnalyticsCurrencyFilter({ selected, onChange }) {
  const mixpanel = useMixpanel();
  const { settings: supplierSettings } = useSelector((state) => state.role.supplier);
  const supportedCurrenciesForSupplier = getSupportedCurrenciesForSupplier(supplierSettings);

  const onToggle = (value) => {
    reportBusinessActionToMixpanel(mixpanel, 'sales-dashboard-currency', { currency: selected });
    onChange(value);
  };

  if (supportedCurrenciesForSupplier.length === 1) {
    onChange(supportedCurrenciesForSupplier[0]);
    return null;
  }

  const currencyOptions = supportedCurrenciesForSupplier.map((currency) => {
    const currencyData = CURRENCIES.find((currencyData) => currencyData.value === currency);
    return {
      value: currencyData.value,
      label: currencyData.symbol,
    };
  });

  return (
    <div className={styles.currencyFilterWrapper}>
      <AnalyticsToggler selected={selected} onChange={onToggle} options={currencyOptions} />
    </div>
  );
}

AnalyticsCurrencyFilter.propTypes = {
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
